

























































































































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';
import { IQuote } from '@/models';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
    biddingEnvironmentInput: Vue & {
      updateSelf: () => void;
      blur: () => void;
    };
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteBiddingEnvironmentDrawerListItem',

  components: { ErrorAlert },

  props: {
    quote: Object as PropType<IQuote>
  },

  data() {
    return {
      menu: false,
      loading: false,
      isFormValid: false,
      errorMessage: '',
      detailErrorMessage: '',

      biddingEnvironment: this.quote.bidding_environment,
      searchQuery: '',

      biddingEnvironments: ['IHH Only', 'IHH+']
    };
  },

  watch: {
    'quote.bidding_environment': {
      handler(value: string) {
        this.biddingEnvironment = value;
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      setBiddingEnvironment: 'quote/setBiddingEnvironment'
    }),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    close() {
      this.menu = false;
    },

    createNewBiddingEnvironment(search: string) {
      this.biddingEnvironment = search;
      // update the combo-box v-model data with whats in the field currently
      this.$refs.biddingEnvironmentInput.updateSelf();
      this.$refs.biddingEnvironmentInput.blur();
    },

    applyQuoteBiddingEnvironment() {
      if (this.validateForm()) {
        this.clearAllErrors();
        this.loading = true;

        this.setBiddingEnvironment({
          id: this.quote.number,
          bidding_environment: this.biddingEnvironment
        })
          .then(() => {
            (this.$refs.biddingEnvironment as any).save(
              this.biddingEnvironment
            );

            this.$emit('change');
            this.close();
          })
          .catch(error => {
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
